module.exports = __webpack_public_path__ + "static/media/emoji.ce1c5920.svg";